module.exports = __webpack_public_path__ + "static/Continental-4de7870ff6d4f54fb79bac56018a05a4.png";